export default {"src":"/_next/static/media/black.34fb20f8.svg","height":80,"width":81,"blurWidth":0,"blurHeight":0};